
import { Paper } from "@mui/material";
import { EntityId } from "@reduxjs/toolkit";
import { useParams } from "react-router-dom";
import Header from "../../../../components/header/Header";
import CategoryContainer from "../../../category/container/category.container/category.container";
import CSSettingContainer from "../../../cssetting/cs.setting.container/cs.setting.container";
import { OrganizationDetailsContainer } from "../../../organization/presantation/organization.add.presentation/organization.add.styles";
import SubCategoryContainer from "../../../subcategory/container/subcategory.container/subcategory.container";
import { useGetProjectByIdQuery } from "../../api/projectApiSlice";
import ProjectDetailsContainer from "../../container/project.details.container/project.details.container";
const ProjectDetailsPage = () => {
  const { projectId } = useParams()
  const {
    data: projectDetails,
    
  } = useGetProjectByIdQuery(projectId as EntityId);
  return (
    <div>
      <Header title="Project" />
      <ProjectDetailsContainer projectId={projectId!} />
      <OrganizationDetailsContainer className="">
        <Paper
          elevation={3}
          className="st-info"
          style={{
            flexDirection: 'row',
            padding: 20,
            justifyContent: 'space-between',
            marginBottom: 80,
            overflow: 'inherit'
          }}
        >
          <CategoryContainer />
          <SubCategoryContainer />
          {projectDetails && (
            <CSSettingContainer
              projectId={projectId as EntityId}
              rewardSystem={
                projectDetails.entities[projectDetails.ids[0]]!.reward_system
              }
            />
          )}
        </Paper>
      </OrganizationDetailsContainer>
    </div>
  )
}

export default ProjectDetailsPage
